import { getIncentiveCampaignRanking } from './get-ranking';
import { getIncentiveCampaignRankingResults } from './get-ranking-results';

export const ranking = {
  get: getIncentiveCampaignRanking,
  results: getIncentiveCampaignRankingResults,
};
